import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_daily_closings`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}





function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_daily_closings/${id}`, options)
    .then(response => {
      let daily_closings = jsona.deserialize(response.data);
      delete daily_closings.links;
      return daily_closings;
    });
}

function add(daily_closings) {
  
  console.log(daily_closings);
  const payload = jsona.serialize({
    stuff: daily_closings,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_daily_closings`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(daily_closings) {
  const payload = jsona.serialize({
    stuff: daily_closings,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_daily_closings/${daily_closings.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {``
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_daily_closings/${id}`, options);
}



// function last_no() {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/daily_closings/last/no`, options)
//     .then(response => {
//       return response.data;
//     });
// }


export default {
  list,
  get,
  add,
  update,
  destroy
};

